// extracted by mini-css-extract-plugin
module.exports = {"card":"ImportResult_card_17Msj"};